import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { HeightProps } from 'styled-system';

import { Box } from 'components/Box';
import { Image } from 'components/Image';

const BaseLogoContainer = styled(Box)`
  svg,
  canvas,
  img {
    height: 100%;
    width: auto;
  }
`;

export function BaseLogoLegacy({
  children,
  height,
  ...props
}: {
  children: ReactNode;
} & HeightProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BaseLogoContainer position="relative" height={height} {...props}>
      <canvas width="167.883" height="167.883" />
      <Box position="absolute" height="100%" left={0} top={0}>
        <Image
          width={72}
          height={72}
          layout="responsive"
          src="/static/images/logo-mark.png"
          srcSet="/static/images/logo-mark.png, /static/images/logo-mark@2x.png 2x, /static/images/logo-mark@3x.png 3x"
          alt="Idealist logo"
          webp
          alwaysShow
        />
      </Box>
      <canvas width="41.379" height="167.883" />
      {children}
    </BaseLogoContainer>
  );
}
